import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import Loading from '../../components/Loading';
import fetch from '../../utils/fetch';
import Product from "./../Products/singleproduct"
import PaginationBtn from '../../components/PaginationBtn';
import _ from 'lodash';
import { useDispatch } from 'react-redux';
import { setAlert } from '../../store/alert';

function Search() {
	const dispatch = useDispatch();
	const { category, query } = useParams();
	const [products, setProducts] = useState([]);
	const [searching, setSearching] = useState(false);
	const [groupPosition, setGroupPosition] = useState(0);
	const [searchesFound, setSearchesFound] = useState(0);

	useEffect(() => {
		searchQuery();
	}, [query, category]);

	useEffect(() => {
		window.scroll({ top: 0, behavior: 'smooth' });
	}, [groupPosition, query, category]);

	function searchQuery() {
		setSearching(true);
		dispatch(setAlert('Starting search...'));
		fetch
			.get(`searchItems`, { query: query === '*' ? '' : query, item_group: category })
			.then(res => {
				setSearching(false);
				setSearchesFound(res.list.length);
				setProducts(_.chunk(res.list, 30));
				dispatch(setAlert(`Finished searching "${query}"`));
			}) 
			.catch(err => {
				setSearching(false);
				dispatch(setAlert({ type: 'error', message: 'Error searching! ' + err.message }));
			});
	}

	return (
		<div className='main-body'>
			{searching && <Loading />}
			{!searching && (
				<section className='search-header sections' style={{ padding: '10px' }}>
					Found {searchesFound} result{products.length > 1 && 's'} for "{query}"
				</section>
			)}
			{!searching && products.length === 0 && (
				<p className='no-results sections' style={{ padding: '10px' }}>
					We did not find any products matching your search. Please try searching using a different word or category.
				</p>
			)}
			{products.length > 0 && (
				<div className='sections'>
					<div className='products-view' style={{ padding: '10px' }}>
						{products[groupPosition].map((product, index) => (
							<Product data={product} />
							// <Product key={product.item_code} data={product} />
						))}
					</div>
					<PaginationBtn data={{ size: products.length, position: groupPosition, onChange: setGroupPosition }} />
				</div>
			)}
		</div>
	);
}

export default React.memo(Search);
